import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pda-classes',
  templateUrl: './classes.component.html',
  styleUrls: ['./classes.component.scss']
})
export class ClassesComponent implements OnInit {

  config = {
    defaultImage: '/assets/images/classes/classes.jpeg',
    items: [
      {
        path: '/assets/images/classes/pole-dance.jpeg',
        description: 'Es una disciplina art\xEDstica deportiva. Mezcla de rutinas acrob\xE1ticas con diferentes estilos de danza como parte de una coreograf\xEDa o presentaci\xF3n.',
        title: 'Pole Dance',
        name: 'Pole Dance'
      },
      {
        path: '/assets/images/classes/pole-exotic.jpeg',
        description: 'Este estilo se caracteriza por enfatizar las acrobacias, baile y trucos en la barra con zapatos de plataforma. En este estilo se permite ver la sensualidad dentro del performance con una t\xE9cnica propia y estilos diferentes.',
        title: 'Pole Exotic',
        name: 'Pole Exotic'
      },
      {
        path: '/assets/images/classes/stretching.jpeg',
        description: 'Pr\xE1ctica de ejercicios suaves y mantenidos para desarrollar fuerza muscular y ganar un mayor rango de movimiento de todo el cuerpo. Tambi\xE9n podemos realizar movimientos m\xE1s fuertes y con mayor destreza, depender\xE1 del nivel del alumno. Previene lesiones y la rigidez muscular. Hace tu cuerpo m\xE1s flexible y lo convierte en una herramienta importante para la diversidad de deportes y danzas en general.',
        title: 'Stretching',
        name: 'Stretching'
      }
    ]
  };

  constructor() { }

  ngOnInit(): void {
  }

}
